function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPeople({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.715,
    height: 14.338,
    viewBox: "0 0 19.715 14.338",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M20.715 17.442a.9.9 0 0 1-.9.9H9.065a.9.9 0 0 1-.9-.9 5.377 5.377 0 0 1 5.377-5.377h1.792a5.377 5.377 0 0 1 5.381 5.377zM14.442 4a3.585 3.585 0 1 0 3.585 3.585A3.585 3.585 0 0 0 14.442 4zM6.377 4a3.585 3.585 0 1 0 3.584 3.585A3.585 3.585 0 0 0 6.377 4zm.637 13.442a7.272 7.272 0 0 1 2.281-5.054 10.373 10.373 0 0 0-2.524-.323h-.788A4.992 4.992 0 0 0 1 17.048v.394a.9.9 0 0 0 .9.9h5.275a2.688 2.688 0 0 1-.161-.9z",
    transform: "translate(-1 -4)",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/people.75d6b4e33f9c9b6065b6658e4324d9ce.svg";
export { ForwardRef as ReactComponent };